import React from "react";

export default function MobileShell({ children }) {
  return (
    <div className="w-full h-full">
      <span>
        <div className="w-full h-full overflow-x-auto overflow-y-hidden">
          {children}
        </div>
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/Layout/MobileShell.js